const qaResponse = {
  'responseNotes': 'required'
};

export {
  qaResponse
};